
import { authEmailService } from './services/auth';

/**
 * Email service facade to be used throughout the application
 * For auth-related emails, supabase's built-in functionality is used
 */
export const emailService = {
  // Auth Email Service
  sendVerificationEmail: authEmailService.sendVerificationEmail,
  triggerPasswordReset: authEmailService.triggerPasswordReset,
  sendPasswordChangedEmail: authEmailService.sendPasswordChangedEmail,
  sendMagicLink: authEmailService.sendMagicLink,
  sendNewLoginEmail: authEmailService.sendNewLoginEmail
};
